<template>
</template>

<script>
import eventBus from "@/assets/js/event/EventBus.js";
import router from '@/router'
import * as cmModal from "@/assets/js/cm-modal.js";

export default {
    name: "ChangeMember",
    mounted() {
        cmModal.init();
        cmModal.closeAllModal();
        
        // HTTP GET Params，判斷是否為"重設密碼"或"重設信箱"
        if(this.$route.query.change!=undefined && this.$route.query.change!=""
            && this.$route.query.key!=undefined && this.$route.query.key!="" ) {
            // HTTP GET Params    
            const change = this.$route.query.change;
            const key = this.$route.query.key;

            // event emit
            if(change == "email") {
                eventBus.$emit(process.env.VUE_APP_EVENT_EMIT_CHANGE_MEMBER_EMAIL, this.$i18n, key);
            }
            else if(change == "password") {
                eventBus.$emit(process.env.VUE_APP_EVENT_EMIT_CHANGE_MEMBER_PASSWORD, this.$i18n, key);
            }
            
            router.push({name: process.env.VUE_APP_ROUTER_HOME});
            return;
        }

        location.href = "/";
    }
};
</script>